var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[_vm.role.toLowerCase(), 'role-tag']},[_c('i'),_vm._v(" "+_vm._s(_vm.ROLE_MAP[_vm.role])+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }